module.exports = __webpack_public_path__ + "9ffbe3d533b0956fb9e44499abd5c339.png";